import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

export const calendarBillsQueryAtom = createQueryAtomFactory(
  'calendar.bills',
  (params: { fromDate: string; toDate: string; facilityId?: string }) => ({
    bills: {
      __args: {
        filter: {
          fromDueDate: params.fromDate,
          toDueDate: params.toDate,
          ...(params.facilityId ? { facilityIDs: [params.facilityId] } : {}),
        },
        pagination: {
          limit: 500,
          offset: 0,
        },
      },
      entries: {
        id: true,
        documentNumber: true,
        documentDate: true,
        dueDate: true,
        status: true,
        type: true,
        amount: {
          amount: true,
          currencyCode: true,
        },
        facility: {
          id: true,
        },
        account: {
          id: true,
        },
        timestamps: {
          createdAt: true,
          updatedAt: true,
        },
      },
      page: {
        total: true,
      },
    },
  }),
);
